import * as React from "react";

interface Props {
  scale?: number;
}

export const LogoIcon: React.FC<Props> = ({ scale = 1 }) => {
  return <img width={400 * scale} height={400 * scale} src={"/logo.webp"} alt={"StashIt logo"} />;
};
